const isValidMobile = (mobile) => {
  if (!mobile) return false;
  const digitsOnly = mobile.replace(/\D/g, "");
  if (/^07\d{9}$/.test(digitsOnly)) return true;
  if (/^\d{7,15}$/.test(digitsOnly)) return true;
  return false;
};

const isValidEmail = (email) => {
  if (!email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
};

export { isValidMobile, isValidEmail };
